var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08221 14.8889H6.5646C5.15264 14.8889 4.44667 14.8889 3.8722 15.0803C2.57878 15.5112 1.56662 16.6227 1.17426 18.0432C1 18.6741 1 19.4494 1 21M13.6468 6C13.6468 8.76142 11.6084 11 9.09396 11C6.57949 11 4.54111 8.76142 4.54111 6C4.54111 3.23858 6.57949 1 9.09396 1C11.6084 1 13.6468 3.23858 13.6468 6ZM10.1057 21L13.2435 20.0154C13.3937 19.9683 13.4689 19.9447 13.5389 19.9094C13.6012 19.878 13.6603 19.8398 13.7155 19.7953C13.7777 19.7452 13.8329 19.6845 13.9434 19.5631L20.4761 12.3889C21.1746 11.6219 21.1746 10.3782 20.4761 9.61108C19.7776 8.84403 18.6452 8.84404 17.9467 9.6111L11.4141 16.7854C11.3036 16.9067 11.2483 16.9674 11.2027 17.0357C11.1622 17.0963 11.1274 17.1612 11.0988 17.2296C11.0666 17.3065 11.0451 17.389 11.0022 17.5541L10.1057 21Z",
    stroke: "#E9C6FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBtn);
export default __webpack_public_path__ + "static/media/admin_btn.d3c884d89b422587ff4ab7110aaea4c7.svg";
export { ForwardRef as ReactComponent };